import React from 'react';
import Widget from './Widget';
import ScatterPlot from './d3/ScatterPlot';

const ScatterPlotWrapper = ({
    data,
    fullData,
    filteredTableSchedules,
    selectedMDRM,
    onPointClick,
    selectMode,
    onAreaSelect,
    setSelectMode,
    hiddenSchedules,
    setHiddenSchedules,
    onResetSelection,
}) => (
    <Widget title="Scatter Plot" className="scatter-plot-widget">
        <ScatterPlot
            data={data}
            fullData={fullData}
            filteredTableSchedules={filteredTableSchedules}
            selectedMDRM={selectedMDRM}
            onPointClick={onPointClick}
            selectMode={selectMode}
            onAreaSelect={onAreaSelect}
            setSelectMode={setSelectMode}
            hiddenSchedules={hiddenSchedules}
            setHiddenSchedules={setHiddenSchedules}
            onResetSelection={onResetSelection}
        />
    </Widget>
);

export default ScatterPlotWrapper;
